import { RuleEngineEntities } from '@bimser/components/dist/BCRuleManager';
import { IDictionary, isNullOrUndefined } from '@bimser/core';

interface IConditionTestItem {
	fact: string;
	operator: RuleEngineEntities.OperationType;
	value: number | string;
}

type Primitive = string | number | boolean;

class ConditionTesterClass {
	private Equals(a: Primitive, b: Primitive) {
		return a == b;
	}

	private NotEquals(a: Primitive, b: Primitive) {
		return a != b;
	}
	private StartsWith(a: string, b: string) {
		return a?.startsWith(b);
	}
	private EndsWith(a: string, b: string) {
		return a?.endsWith(b);
	}
	private Contains(a: string, b: string) {
		return a && a.indexOf(b) > -1;
	}
	private NotContains(a: string, b: string) {
		return !a || a.indexOf(b) === -1;
	}
	private GreaterThan(a: number, b: number) {
		return a > b;
	}
	private GreaterThanOrEqual(a: number, b: number) {
		return a >= b;
	}
	private LessThan(a: number, b: number) {
		return a < b;
	}
	private LessThanOrEqual(a: number, b: number) {
		return a <= b;
	}
	private Null(a: Primitive) {
		return isNullOrUndefined(a) || this.isEmptyString(a as string);
	}
	private NotNull(a: Primitive) {
		return !isNullOrUndefined(a) && !this.isEmptyString(a as string);
	}

	private isEmptyString(value: string): boolean {
		return typeof value === 'string' && value.trim() === '';
	}

	private isNumber(value) {
		return typeof value === 'number' && !isNaN(value);
	}

	compare(condition: IConditionTestItem, values: IDictionary<any>): boolean {
		const { value, operator, fact } = condition;
		switch (operator) {
			case 'Equals': {
				return this.Equals(value, values[fact]);
			}
			case 'NotEquals': {
				return this.NotEquals(value, values[fact]);
			}
			case 'StartsWith': {
				return this.StartsWith(value as string, values[fact]);
			}
			case 'EndsWith': {
				return this.EndsWith(value as string, values[fact]);
			}
			case 'Contains': {
				return this.Contains(value as string, values[fact]);
			}
			case 'NotContains': {
				return this.NotContains(value as string, values[fact]);
			}
			case 'GreaterThan': {
				if (this.isNumber(value) && this.isNumber(values[fact])) {
					return this.GreaterThan(value as number, values[fact]);
				}
				break;
			}
			case 'GreaterThanOrEqual': {
				if (this.isNumber(value) && this.isNumber(values[fact])) {
					return this.GreaterThanOrEqual(value as number, values[fact]);
				}
				break;
			}
			case 'LessThan': {
				if (this.isNumber(value) && this.isNumber(values[fact])) {
					return this.LessThan(value as number, values[fact]);
				}
				break;
			}
			case 'LessThanOrEqual': {
				if (this.isNumber(value) && this.isNumber(values[fact])) {
					return this.LessThanOrEqual(value as number, values[fact]);
				}
				break;
			}
			case 'Null': {
				return this.Null(values[fact]);
			}
			case 'NotNull': {
				return this.NotNull(values[fact]);
			}
			default: {
				return false;
			}
		}
	}
}

const ConditionTester = new ConditionTesterClass();

export { ConditionTester, IConditionTestItem };
